import { AiOutlineApple } from "react-icons/ai";
import { FaLinux } from "react-icons/fa";
import { LuChrome } from "react-icons/lu";
import { TbBrandAndroid, TbBrandEdge, TbBrandFirefox, TbBrandOpera, TbBrandSafari, TbBrandWindowsFilled, TbBrowser } from "react-icons/tb";

export const UserAgentOSIcon = {
   linux: FaLinux,
   windows: TbBrandWindowsFilled,
   mac: AiOutlineApple,
   android: TbBrandAndroid,
};

export const UserAgentBrowserIcon = {
   firefox: TbBrandFirefox,
   chrome: LuChrome,
   safari: TbBrandSafari,
   opera: TbBrandOpera,
   edge: TbBrandEdge,
   unknow: TbBrowser,
};